import React from "react";
import "./css/PerformanceAndROI.css";

// Import assets
import ImpressionsIcon from "../../assets/Eye.png";
import ClicksIcon from "../../assets/Cleaner Pages.png";
import PublisherIcon from "../../assets/Revenue_Graph.png";
import GeoIcon from "../../assets/map.png";

const PerformanceAndROI = () => {
    const metrics = [
        {
            icon: ImpressionsIcon,
            label: "Impressions",
            value: "Delivered in real time",
        },
        {
            icon: ClicksIcon,
            label: "Clicks",
            value: "Track engagement clearly",
        },
        {
            icon: PublisherIcon,
            label: "Publisher Performance",
            value: "See results by publisher",
        },
        {
            icon: GeoIcon,
            label: "Geo Insights",
            value: "Country, state, city breakdown",
        },
    ];

    return (
        <section className="performance-roi-section">
            <div className="performance-roi-container">
                <div className="performance-roi-header">
                    <h2 className="performance-roi-title">
                        Track, Measure, and Optimize Performance
                    </h2>
                    <p className="performance-roi-subtext">
                        Get full visibility into where your ads appear and how they perform.
                    </p>
                </div>

                <div className="performance-metrics-grid">
                    {metrics.map((metric, index) => (
                        <div key={index} className="metric-card">
                            <div className="metric-icon-wrapper">
                                <img src={metric.icon} alt={metric.label} className="metric-icon" />
                            </div>
                            <div className="metric-content">
                                <h3 className="metric-label">{metric.label}</h3>
                                <p className="metric-value">{metric.value}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default PerformanceAndROI;
